import * as React from 'react';
import {useAcceptLanguage} from '@shopify/react-network';
import {I18nUniversalProvider} from '@shopify/react-i18n-universal-provider';
import {useI18n} from '@shopify/react-i18n';
import en from 'locales/en.json';
import {Translations as CommonTranslations} from 'locales';

interface I18nProps {
  locale?: string;
  children?: React.ReactNode;
}

interface TranslationsProps {
  children?: React.ReactNode;
}

export function I18n({locale, children}: I18nProps) {
  const fallback = {
    code: typeof window === 'undefined' ? 'en' : navigator.language,
    quality: 1.0,
  };
  const [language] = useAcceptLanguage(fallback);

  return (
    <I18nUniversalProvider locale={locale || language.code}>
      <Translations>{children}</Translations>
    </I18nUniversalProvider>
  );
}

export function Translations({children}: TranslationsProps) {
  const [, ShareTranslations] = useI18n({
    id: 'Root',
    fallback: en,
    translations(locale) {
      return CommonTranslations[locale] ?? CommonTranslations.en;
    },
  });

  return <ShareTranslations>{children}</ShareTranslations>;
}
